import { APP_LS_NAMESPACE_ID, APPLICANT } from "src/constants";
import { SMALL_BUSINESS, SMALL_BUSINESS_LOAN } from "src/features/LoansHome/Products/constants";
import { STATUS_APPLICATION_IN_REVIEW, STATUS_SUBMITTED, STATUS_REQUEST_APPROVAL, STATUS_FINAL_CLOSING, SMARTMATCH_TYPE_LOAN_OFFICER } from "src/services/constants";

const mkSmallBusinessStage = [
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_APPLICATION_IN_REVIEW,
                        "display_name": STATUS_APPLICATION_IN_REVIEW
                    }
                ]
            }
        ],
        "name": STATUS_SUBMITTED,
        "display_name": STATUS_SUBMITTED
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_REQUEST_APPROVAL,
                        "display_name": STATUS_REQUEST_APPROVAL
                    }
                ]
            }
        ],
        "name": STATUS_APPLICATION_IN_REVIEW,
        "display_name": STATUS_APPLICATION_IN_REVIEW
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_FINAL_CLOSING,
                        "display_name": STATUS_FINAL_CLOSING
                    }
                ]
            }
        ],
        "name": STATUS_REQUEST_APPROVAL,
        "display_name": STATUS_REQUEST_APPROVAL
    },
    {
        "children": [
            {
                "stages": []
            }
        ],
        "name": STATUS_FINAL_CLOSING,
        "display_name": STATUS_FINAL_CLOSING
    }
]


const APPLS_SMALL_BUSINESS_LOAN_STAGES_CONFIG = {
    id: '154878745215745754',
    namespace_id: APP_LS_NAMESPACE_ID,
    loan_type: [SMALL_BUSINESS],
    sub_loan_types: [SMALL_BUSINESS_LOAN],
    stages: mkSmallBusinessStage,
    roles: [SMARTMATCH_TYPE_LOAN_OFFICER, APPLICANT],
};

export const smallBusinessLoanStages = [
    APPLS_SMALL_BUSINESS_LOAN_STAGES_CONFIG
]